import { TCreateUserDto } from "types/Core/Users/createUserDto";

const createUserMapper = (formValues: any): TCreateUserDto => ({
  username: formValues.username,
  password: formValues.password,
  name: formValues.name,
  lastname: formValues.lastname,
  mail: formValues.mail,
});

export default createUserMapper;
